import { Client } from '@langchain/langgraph-sdk';

import { CONFIG } from 'src/config-global';

export const createLangGraphClient = () =>
  new Client({
    apiUrl: CONFIG.langgraph.url,
    defaultHeaders: CONFIG.langgraph.apiKey ? { 'X-Api-Key': CONFIG.langgraph.apiKey } : undefined,
  });
